export var createCallcenterSettingsApi = function (baseUrl, http) {
    var url = baseUrl + "/callcenter";
    return {
        getGlobalCallOptions: function () { return http.get(url + "/queues/callOptions"); },
        setGlobalCallOptions: function (dto) { return http.put(url + "/queues/callOptions", dto); },
        getCustomBusyStatuses: function () { return http.get(url + "/customBusyStatuses"); },
        addCustomBusyStatus: function (name) { return http.post(url + "/customBusyStatuses", { name: name }); },
        updateCustomBusyStatus: function (_a) {
            var id = _a.id, name = _a.name;
            return http.put(url + "/customBusyStatuses/" + id, { name: name });
        },
        deleteCustomBusyStatus: function (id) { return http.delete(url + "/customBusyStatuses/" + id); }
    };
};
//# sourceMappingURL=index.js.map